<template>
  <router-view />
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css'
import { readTheme, applyTheme } from '@/theme'

export default {
  name: 'App',
  created() {
    // index.html sets this before first paint; re-applying keeps the
    // theme-color meta in step if the page was restored from bfcache.
    applyTheme(readTheme())
  },
}
</script>

<style>
@import './components/TruckList.css';

html, body, #app { height: 100%; margin: 0; }

body {
  background: var(--bg);
  color: var(--text);
  -webkit-font-smoothing: antialiased;
  overscroll-behavior-y: none;
}
</style>
